export const CHANGE_ROW_SELECTION = 'TABLE:CHANGE_ROW_SELECTION';
export const RESET_ROWS_SELECTION = 'TABLE:RESET_ROWS_SELECTION';
export const UPDATE_SORTING = 'TABLE:UPDATE_SORTING';
export const INIT_TABLE = 'TABLE:INIT_TABLE';
export const TOGGLE_EXPANDABLE_ROW = 'TABLE:TOGGLE_EXPANDABLE_ROW';
